import { createReducer, on } from '@ngrx/store';
import { ActiveComponentChanged, ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import {
  ClearSearchGroupTemplatesFilters,
  CodeChanged,
  InactiveChanged,
  PanelStatusChanged,
  RemarksChanged,
} from '../actions/search-group-templates.actions';

export interface SearchGroupTemplatesState {
  panelExpanded: boolean;
  code: string;
  remarks: string;
  inactive: boolean;
}

const initialState: SearchGroupTemplatesState = {
  panelExpanded: true,
  code: '',
  remarks: '',
  inactive: false,
};

export const SearchGroupTemplatesReducer = createReducer(
  initialState,
  on(PanelStatusChanged, (state) => ({
    ...state,
    panelExpanded: !state.panelExpanded,
  })),
  on(CodeChanged, (state, { code }) => ({
    ...state,
    code,
  })),
  on(RemarksChanged, (state, { remarks }) => ({
    ...state,
    remarks,
  })),
  on(InactiveChanged, (state, { inactive }) => ({
    ...state,
    inactive,
  })),
  on(ClearSearchGroupTemplatesFilters, (state) => ({
    ...state,
    panelExpanded: true,
    code: '',
    remarks: '',
    inactive: false,
  })),
  on(ActiveComponentChanged, () => ({
    panelExpanded: true,
    code: '',
    remarks: '',
    inactive: false,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
